import React from 'react';
import PropTypes from 'prop-types';
import CloseButton from '../../images/icons/close-button.svg';

import './style.less';

export default class LightBox extends React.Component {
  static propTypes = {
    onClose: PropTypes.func,
    onClick: PropTypes.func,
    className: PropTypes.string
  };

  constructor() {
    super();

    this.onClick = this.onClick.bind(this);
    this.onClose = this.onClose.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
  }

  onClose(event) {
    if (this.props.onClose) {
      this.props.onClose(event);
    }
  }

  onClick(event) {
    if (event.target.id === 'light-box') {
      this.onClose(event);
    } else if (this.props.onClick) {
      this.props.onClick(event);
    }
  }

  onKeyDown(event) {
    if (!event.defaultPrevented && event.key === 'Escape') {
      this.onClose(event);
    }
  }

  componentWillMount() {
    document.addEventListener("keydown", this.onKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.onKeyDown);
  }

  render() {
    let classNames = [ 'light-box-component' ];
    let closeButton;

    if (this.props.className) classNames.push(this.props.className);

    if (this.props.onClose) {
      closeButton =
        <div className="light-box-close-button" onClick={this.onClose}>
          <img src={CloseButton} role="presentation" />
        </div>;
    }

    return(
      <div id="light-box" className={classNames.join(' ')} onClick={this.onClick}>
        <div id="light-box-contents" className="light-box-contents">
          {closeButton}
          <div className="light-box-inner">{this.props.children}</div>
        </div>
      </div>
    );
  }
}


/** WEBPACK FOOTER **
 ** ./src/components/LightBox/index.js
 **/